import useQuery from '@/core/hooks/api/useQuery';
import Api from '@/core/lib/new-architecture/api';
import type { Query } from '@/core/lib/new-architecture/query/types.query';
import type { BadgesResult } from '@/core/types/badge';

const keys = {
  base: ['KEY_TO_PREVENT_COLLISIONS', '/badges'] as const,
};

const useBadges: Query<BadgesResult> = ({ enabled }) => {
  return useQuery({
    queryKey: keys.base,
    queryFn: () => Api.query.badges.get(),
    enabled,
  });
};

useBadges.prefetch = async ({ queryClient }) => {
  await queryClient.query({
    queryKey: keys.base,
    queryFn: () => Api.query.badges.get(),
  });
};

export default { useBadges };
